import { Navigate, useLocation } from 'react-router-dom';

export default function ResetPasswordRedirect() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const scope = params.get('scope');
  const target = scope === 'customer' ? '/customer/reset-password' : '/provider/reset-password';

  return <Navigate to={`${target}${location.search}`} replace />;
}
